import { sharedSpacing } from 'app/config/grid';

/**
 * Get the shared spacing.
 */
export const getSharedSpacing = () => sharedSpacing;
